import { useQuery } from '@tanstack/react-query';
import { initApis } from '../api/Api';
import { QUERY_KEYS } from './queryKeys';
import { type IConfig } from '../types/config';

export const useConfigQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.config],
    queryFn: async () => {
      try {
        return await initApis();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    staleTime: Infinity,
    retry: 3,
  });
};

type ConfigQueryType<Data, Error> = {
  isLoading: boolean;
  data: Data | undefined;
  error: Error | null;
};

export type useInitiateConfigQueryType = {
  config: ConfigQueryType<IConfig, Error>;
};

export const useInitiateConfigQuery = (): useInitiateConfigQueryType => {
  const configQuery = useConfigQuery();

  return {
    config: {
      isLoading: configQuery.isLoading,
      data: configQuery.data,
      error: configQuery.error,
    },
  };
};
